import { render, staticRenderFns } from "./ListDocumentosDispositivos.vue?vue&type=template&id=2877c274"
import script from "./ListDocumentosDispositivos.vue?vue&type=script&lang=js"
export * from "./ListDocumentosDispositivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports